(function($) {

  'use strict';

  function Challenge() {

    var self = this,
      $form = null,
      $btnSubmit = null,
      $formInner = null,
      $formField = null,
      $formBox = null,
      options = {
        'example': null
      };

    //-- Clear form
    function clearForm() {
      $formField.val('');
      $formBox.removeClass('is-focus');
      $('input[type="checkbox"]').prop('checked', false);
    }

     //-- Ask Question Form Validation
     function initValidation() {
        if ($form.valid()) {
          
          $btnSubmit.hide();
          var msgSuccess = $form.find('.js-form-success');
          msgSuccess.fadeIn();

          var formData = new FormData($form[0]);
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: formData,
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false,
                success: function(res) {
                    // Manual error from server
                    var msgSuccess = $form.find('.js-form-success');
                    var msgError = $form.find('.js-form-error');

                    // msgSuccess.hide();
                    msgError.hide();

                    if (res.success === false) {
                        if (res.message) {
                          msgError.html(res.message);
                        }
                        msgError.show();
                        return false;
                    }

                    // Show message
                    if (res.success) {
                        if (res.message) {
                          msgSuccess.html(res.message);
                        }
                        // clearForm();
                        // $btnSubmit.fadeOut();
                        // msgSuccess.fadeIn();

                        if (typeof dataLayer !== 'undefined') {
                          dataLayer.push({'event': 'form-submit'});
                        }
                    }
                },
                error: function(errorThrown) {
                    // Show message
                    console.log('Error: ', errorThrown);
                    console.log(formData);
                    $('.js-form-error').fadeIn();
                    return false;
                }
            }); 
        }

    }


    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //extends options
      for (var i in opts) { options[i] = opts[i]; }

      // Caching
      $form = $('#challengeForm');
      $formInner = $('.js-form-inner');
      $formField = $('.js-form-field');
      $formBox = $('.js-form-box');

      $btnSubmit = $('#challengeFormBtn');
      $form.validate();
      $btnSubmit.on('click', function () {
        initValidation()
      });


    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.Challenge = Challenge;

}(jQuery));